import React from "react";
import { WebTracerProvider } from "@opentelemetry/sdk-trace-web";
import { BatchSpanProcessor } from "@opentelemetry/sdk-trace-base";
import { ZoneContextManager } from "@opentelemetry/context-zone";
// import { FetchInstrumentation } from '@opentelemetry/instrumentation-fetch';
// import { registerInstrumentations } from '@opentelemetry/instrumentation';
import { Resource } from "@opentelemetry/resources";
import { OTLPTraceExporter } from "@opentelemetry/exporter-trace-otlp-http";
import { Platform } from "@raven/provisioning/native/Platform";
import { useParams } from "react-router";

const prodReceiverURL =
  "https://staging-raven-gke.raven-cloud.com/opentelemetry-collector-frontend/v1/traces";
const devReceiverURL =
  "https://staging-raven-gke.raven-cloud.com/opentelemetry-collector-dev/v1/traces";

const isProduction = process.env.NODE_ENV === "production";

export type TraceProviderProps = {
  children?: React.ReactNode;
};

/** Only used in reporting routes for now. */
export const TraceProvider = ({
  children,
}: TraceProviderProps): React.JSX.Element => {
  const { ckey: tenant } = useParams();

  const platform = Platform.OS;

  const collectorOptions = {
    url:
      !isProduction && window.location.hostname === "localhost"
        ? devReceiverURL
        : prodReceiverURL,
  };
  // Trace provider (Main aplication trace)
  const provider = new WebTracerProvider({
    resource: new Resource({
      "service.name": "Bifrost",
      "service.customer": tenant ?? "",
      "service.platform": platform,
    }),
  });

  // Exporter (opentelemetry collector hidden behind bff proxy)
  const exporter = new OTLPTraceExporter(collectorOptions);

  // Instrumentation configurations for frontend
  // const fetchInstrumentation = new FetchInstrumentation({
  //   ignoreUrls : ["https://some-ignored-url.com"]
  // });

  // fetchInstrumentation.setTracerProvider(provider);

  provider.addSpanProcessor(new BatchSpanProcessor(exporter));

  provider.register({
    contextManager: new ZoneContextManager(),
  });

  // Registering instrumentations
  // registerInstrumentations({
  //     instrumentations: [new FetchInstrumentation()],
  // });

  return <>{children}</>;
};
